export default "__VITE_ASSET__CQGquFki__"